import UploadCsvIcon from "./UploadCsvIcon.png";
import DownloadCsvIcon from "./DownloadCsvIcon.png";
import SuccessIcon from "./successIcon.png";

export const ICONS = {
  UploadCsvIcon,
  DownloadCsvIcon,
  SuccessIcon,
};
